import { ChevronLeft, LucideSquareArrowOutUpRight, ArrowLeft } from 'lucide-react';
import React, { useState } from 'react';
import useSignalStore from '@/stores/layout/signalStore';
import { useSurveyStore } from '@/stores/survey/store';

interface StepButtonBlockProps {
    singleMultiRadioButton: string;
    singleText: string;
    multiText: Array<{ text: string }>;
    finishButton: {
        target: string;
        title: string;
        url: string;
    };
    onStepButtonClick: (answer: string, isFinish: boolean) => void;
}

const StepButtonBlock: React.FC<StepButtonBlockProps> = ({
    singleMultiRadioButton,
    singleText,
    multiText,
    finishButton,
    onStepButtonClick,
}) => {
    const { setIsOpen } = useSignalStore();
    const { setCurrentStep } = useSurveyStore();

    const [selectedAnswer, setSelectedAnswer] = useState<string | null>(null);

    const handleButtonClick = (answer: string, isFinish: boolean = false) => {
        setSelectedAnswer(answer);

        // Delay the step transition so the selection is visible
        setTimeout(() => {
            onStepButtonClick(answer, isFinish);

            if (isFinish) {
                setCurrentStep(0);
                setIsOpen(false);
            }
        }, 300); // 600ms delay
    };

    return (
        <div className='space-y-3 !mt-5'>
            {singleMultiRadioButton === 'single' && (
                <button
                    onClick={() => handleButtonClick(singleText)}
                    className='w-full py-3 px-6 bg-gradient-to-r from-[#e7c282] text-base to-[#b48336] hover:brightness-105 text-black font-bold rounded-xl transition-all flex items-center justify-center relative'
                >
                    {singleText}
                    <ChevronLeft className='size-5 absolute left-4' />
                </button>
            )}

            {singleMultiRadioButton === 'multi' &&
                multiText.map((item, index) => (
                    <button
                        key={index}
                        onClick={() => handleButtonClick(item.text)}
                        className={`w-full px-4 py-3 flex gap-2 items-center rounded-xl border justify-between border-gray-400 dark:border-white/50 bg-white dark:bg-white/5 transition-all font-bold ${
                            selectedAnswer === item.text
                                ? 'border-progress'
                                : 'text-primary dark:text-white'
                        }`}
                    >
                        <span className='text-sm'>{item.text}</span>
                        <input
                            type='radio'
                            name='survey-radio'
                            className='form-radio text-blue-600 mr-3'
                            checked={selectedAnswer === item.text}
                            readOnly
                        />
                    </button>
                ))}

            {singleMultiRadioButton === 'finish' && (
                <a
                    onClick={() => handleButtonClick(finishButton.title, true)}
                    href={finishButton.url}
                    target={finishButton.target}
                    className='flex justify-between items-center text-sm gap-2 py-3.5 px-6 bg-gradient-to-r from-[#C07808] to-[#EEAC43] hover:brightness-105 text-white font-bold rounded-xl w-full text-center transition-all mt-2'
                >
                    <LucideSquareArrowOutUpRight size={18} />
                    {finishButton.title}
                    <ArrowLeft size={18} />
                </a>
            )}
        </div>
    );
};

export default StepButtonBlock;
